import React, { useState, useEffect } from "react";
import BaseModalAnimated from "../../../components/modal/BaseModalAnimated";
import CustomButton from "../../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showFormErrors } from "../../../helpers/showFormErrors";
import CustomInput from "../../../components/form/CustomInput";
import { sellersResource } from "../../../helpers/configRoutes/backend_helper";
import { reset_seller } from "../../../store/sellers/action";
import { FileInput } from "lucide-react";

const ModalNewSeller = ({ modal, setModal, filters, setFilters }) => {
    const dispatch = useDispatch()
    
    const { seller, validations } = useSelector((state) => state.Seller)

    const [loading, setLoading] = useState(false);

    const validation = useFormik({
        initialValues: seller,
        validationSchema: Yup.object().shape({
            ...validations
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);
            const response = await sellersResource((values.id ? 'put' : 'post'), values, values.id)
            if (response.status) {
                setFilters({ ...filters })
                dispatch(reset_seller())
                setModal({ ...modal, show: false })
            }
            setLoading(false);
        }
    });


    return (
        <BaseModalAnimated setModal={setModal} modal={modal}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                    return false;
                }}
            >
                <div className="px-6 py-5 space-y-6 bg-fr-light text-fr-dark">
                    <h2 className="text-lg font-semibold text-center">
                        {seller.id ? "Editar vendedor" : "Crear vendedor"}
                    </h2>

                    <div className="flex justify-center">
                        <div className="relative flex flex-col items-center">
                            <img
                                className="w-24 h-24 rounded-full object-cover mb-3 border-4 border-fr-muted"
                                src={validation.values.image_profile || "https://placehold.co/96x96"}
                                alt="Profile"
                            />
                            <FileInput
                                format={"img"}
                                name={"image_profile"}
                                validation={validation}
                            />
                        </div>
                    </div>

                    {/* Inputs: 2 en fila + 1 debajo */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <CustomInput
                            label={"Nombre"}
                            type="text"
                            name="name"
                            error={validation?.errors?.name}
                            value={validation?.values?.name}
                            handleChange={validation.handleChange}
                            className="text-sm"
                        />
                        <CustomInput
                            label={"Apellidos"}
                            type="text"
                            name="last_names"
                            error={validation?.errors?.last_names}
                            value={validation?.values?.last_names}
                            handleChange={validation.handleChange}
                            className="text-sm"
                        />
                    </div>

                    <div>
                       
                        <CustomInput
                            label={"Identificador de vendedor"}
                            type="text"
                            name="short_name"
                            error={validation?.errors?.short_name}
                            value={validation?.values?.short_name}
                            handleChange={validation.handleChange}
                            className="text-sm"
                        />
                    </div>
                </div>

                <div className="px-6 py-4 bg-fr-secondary border-t border-fr-muted flex justify-end gap-3 rounded-b-lg">
                    <CustomButton
                        loading={loading}
                        textLoad="Guardando"
                        className="bg-fr-primary hover:bg-fr-primary-hover text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        type="submit"
                    >
                        Guardar
                    </CustomButton>

                    <CustomButton
                        className="bg-fr-danger hover:bg-red-600 text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        onClick={() => setModal({ ...modal, show: false })}
                        type="button"
                    >
                        Cancelar
                    </CustomButton>
                </div>
            </form>

        </BaseModalAnimated>
    );
};

export default ModalNewSeller;
